namespace GeniuzPOS.Customer {
    export class CsCustomerColumns {
        static columnsKey = 'Customer.CsCustomer';
    }
}
